<template>
  <!--footer start-->
  <section class="contact" id="contact" ref="footerPosition">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="section-title">
            <h2>Get In Touch</h2>
          </div>
          <form class="auth-form">
            <div class="form-group">
              <label for="exampleInputName1">Name</label>
              <i class="fa fa-user"></i>
              <input
                required=""
                name="login[username]"
                type="text"
                class="form-control"
                id="exampleInputName1"
                placeholder="User name"
              />
            </div>
            <div class="form-group">
              <label for="exampleInputEmail12">Email</label>
              <i class="fa fa-envelope-o"></i>
              <input
                required=""
                name="login[email]"
                type="email"
                class="form-control"
                id="exampleInputEmail12"
                placeholder="Email"
              />
            </div>
            <div class="form-group">
              <label>Your message</label>
              <i class="fa fa-commenting-o"></i>
              <textarea
                class="form-control"
                name="message"
                id="message"
                cols="30"
                rows="10"
                placeholder="Your Message"
              ></textarea>
            </div>
            <div class="form-group mb-0">
              <button class="btn-theme" type="submit">Send Message</button>
            </div>
          </form>
        </div>
        <div class="col-md-6">
          <div class="section-title">
            <h2>Contact Info</h2>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consecte adipisicing elit sed do eiusmod
            tempor incididunt.
          </p>
          <ul class="contact-box">
            <li>
              <div class="contact-circle">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
              </div>
              <div class="contact-text">
                <h3>Location</h3>
                <p>123 Business Avenue, Hoston, USA</p>
              </div>
            </li>
            <li>
              <div class="contact-circle">
                <i class="fa fa-phone" aria-hidden="true"></i>
              </div>
              <div class="contact-text">
                <h3>Call US</h3>
                <p>+91 123-456-7890</p>
              </div>
            </li>
            <li>
              <div class="contact-circle">
                <i class="fa fa-envelope" aria-hidden="true"></i>
              </div>
              <div class="contact-text">
                <h3>Email Us</h3>
                <p>support@gmail.com</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <!--footer end -->
</template>
<script>
export default {
  name: "Footer",
  mounted() {
    let payload = {
      position: this.$refs["footerPosition"].offsetTop,
      name: "footerPosition",
    };
    this.$emit("windowPosition", payload);
  },
};
</script>
